import SuccessContainer from './SuccessContainer';

export default SuccessContainer;



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/components/Success/index.js